import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import MatchedFeatureItem from './components/MatchedFeatureItem';
import './style.scss';

export default class MatchedIntentsFeatures extends Component {
  static propTypes = {
    closeIntentAndFeatureView: PropTypes.func.isRequired,
    item: PropTypes.shape({
      id: PropTypes.string,
      isHoved: PropTypes.bool,
      key: PropTypes.string,
      matchedFeatures: PropTypes.array,
      showFeatures: PropTypes.bool,
      toUpper: PropTypes.bool,
    }).isRequired,
    matchedIntent: PropTypes.shape({
      color: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      source: PropTypes.string,
    }).isRequired,
    openIntentAndFeatureView: PropTypes.func.isRequired,
  };

  onDoubleClick = e => {
    e.stopPropagation();
  };

  onMouseEnter = e => {
    e.stopPropagation();
    const { item, openIntentAndFeatureView } = this.props;
    openIntentAndFeatureView(item.id);
  };

  onMouseLeave = e => {
    const { closeIntentAndFeatureView } = this.props;
    if (e.target.clientWidth > e.nativeEvent.offsetX) {
      closeIntentAndFeatureView();
    }
  };

  render() {
    const { item, matchedIntent } = this.props;

    return (
      <div styleName="matched">
        <div
          data-test="matched-intent-label"
          id={`matched-intent-label-${item.id}`}
          style={{ borderLeft: `5px solid ${matchedIntent.color}` }}
          styleName={cn('label', {
            hover: item.isHoved, // TODO: Check if setting the hover class is redundant
          })}
          onDoubleClick={this.onDoubleClick}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          <div data-test="matched-intent-text" styleName="text">
            <div styleName="matched-intent-text">{matchedIntent.name}</div>
            {matchedIntent.source === 'ml' && (
              <span className="icon-machine-learning" />
            )}
          </div>
        </div>
        {item.showFeatures && Boolean(item.matchedFeatures) && (
          <div
            className={cn('word-entities-found intent-features', {
              upper: item.toUpper,
            })}
            id={`matched-intent-${matchedIntent.id}`}
          >
            <table>
              <tbody>
                {item.matchedFeatures.map(feature => (
                  <MatchedFeatureItem key={feature.key} feature={feature} />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}
